import { ChangeEvent, useMemo } from 'react';
import useTextInput, { ValidationLogic } from './useTextInput';
import i18n from '../../R/string/i18n';
import { AUTH_TYPE } from '../../domain/auth';

const passwordValidationLogics = (
  authType: 'signup' | 'signin'
): ValidationLogic[] => {
  const commonRules: ValidationLogic[] = [
    {
      logic: (password: string) => password.length <= 0,
      msg: i18n.formPasswordIsRequired()
    },
    {
      logic: (password: string) => password.length <= 7,
      msg: i18n.formPasswordShouldBeOverEight()
    }
  ];

  const enhancedSignupRules: ValidationLogic[] = [
    {
      logic: (password: string) =>
        !/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/.test(password),
      msg: i18n.formPasswordShouldContainUpperLowerNumber()
    }
  ];

  return authType === AUTH_TYPE.SIGN_UP
    ? [...commonRules, ...enhancedSignupRules]
    : commonRules;
};

function usePasswordInput(
  initVal: string,
  authType: 'signup' | 'signin'
): [
  string,
  (e: ChangeEvent<HTMLInputElement>) => void,
  string | undefined,
  boolean
] {
  const validationLogicTranslated = passwordValidationLogics(authType);

  const [password, onChangePassword, passwordErr] = useTextInput(
    initVal,
    validationLogicTranslated,
    1000
  );

  const hasError = useMemo(
    () => validationLogicTranslated.some(({ logic }) => logic(password)),
    [password]
  );

  return [password, onChangePassword, passwordErr, hasError];
}

export default usePasswordInput;
